import styles from './DropdownToggle.module.css';

export const DropdownToggle = ({ isOpen }: { isOpen: boolean }) => {
  return (
    <div className={`${isOpen ? styles.open : ''} ${styles.dropdownToggleContainer}`}>
      <svg fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 0H17.825V1.876H0z" fill="#fff" transform="scale(1.00496 .99502) rotate(45 -.22 3.375)" />
        {!isOpen ? (
          <path d="M0 0H17.825V1.876H0z" fill="#fff" transform="matrix(.71061 -.70358 .71061 .70358 1 13.541)" />
        ) : null}
      </svg>
    </div>
  );
};
